import { useState } from 'react';
import { commentsData } from '@/mocks/home';

function StarIcon({ filled }: { filled: boolean }) {
  return (
    <div className="w-3.5 h-3.5 flex items-center justify-center">
      {filled ? (
        <i className="ri-star-fill text-xs text-accent-500" />
      ) : (
        <i className="ri-star-line text-xs text-foreground-300" />
      )}
    </div>
  );
}

export default function CommentsSection() {
  const [errors, setErrors] = useState<Record<number, boolean>>();

  const handleError = (index: number) => {
    setErrors((prev) => ({ ...prev, [index]: true }));
  };

  return (
    <section id="comments" className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
      <div className="w-full">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1.5 h-7 rounded-full bg-accent-500" />
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">用户评价</h2>
          </div>
          <span className="text-xs text-foreground-500 hidden sm:block">5条真实用户反馈</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mb-4 md:mb-5">
          {commentsData.slice(0, 3).map((item, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200/70 bg-background-50 p-5 md:p-6 hover:border-primary-200 transition-all"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full bg-background-100 overflow-hidden shrink-0 border-2 border-background-200">
                  {!errors[index] ? (
                    <img
                      src={item.avatar}
                      alt={item.name}
                      className="w-full h-full object-cover"
                      onError={() => handleError(index)}
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center bg-primary-100">
                      <i className="ri-user-line text-primary-500 text-sm" />
                    </div>
                  )}
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">{item.name}</p>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <StarIcon key={i} filled={i < item.rating} />
                    ))}
                  </div>
                </div>
                <span className="ml-auto text-xs text-foreground-400 shrink-0">{item.time}</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-2xl mx-auto lg:max-w-none">
          {commentsData.slice(3, 5).map((item, index) => {
            const realIndex = index + 3;
            return (
              <div
                key={realIndex}
                className="rounded-xl border border-background-200/70 bg-background-50 p-5 md:p-6 hover:border-primary-200 transition-all"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-11 h-11 rounded-full bg-background-100 overflow-hidden shrink-0 border-2 border-background-200">
                    {!errors[realIndex] ? (
                      <img
                        src={item.avatar}
                        alt={item.name}
                        className="w-full h-full object-cover"
                        onError={() => handleError(realIndex)}
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center bg-primary-100">
                        <i className="ri-user-line text-primary-500 text-sm" />
                      </div>
                    )}
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-800">{item.name}</p>
                    <div className="flex items-center gap-0.5 mt-0.5">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <StarIcon key={i} filled={i < item.rating} />
                      ))}
                    </div>
                  </div>
                  <span className="ml-auto text-xs text-foreground-400 shrink-0">{item.time}</span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}